import { render, staticRenderFns } from "./TranslateLink.vue?vue&type=template&id=058cee49&"
import script from "./TranslateLink.vue?vue&type=script&lang=js&"
export * from "./TranslateLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports